// src/js/reset/resetButton.js
(() => {
  const resetBtn = document.getElementById('resetForm');
  const registerForm = document.getElementById('registerForm');

  // Si no existe el botón o el formulario, no hacemos nada
  if (!resetBtn || !registerForm) return;

  // Elementos del estado visual (vienen del mixin formUsersRegister.pug)
  const statusSpan = document.getElementById('email-status');
  const inputEmail = document.getElementById('email');

  resetBtn.addEventListener('click', () => {
    // 1. Limpiar formulario
    registerForm.reset();

    // 2. Limpiar estado visual del email
    if (statusSpan) {
      statusSpan.className = '';
      statusSpan.textContent = '';
    }

    // 3. Limpiar clases del input
    if (inputEmail) {
      inputEmail.classList.remove('valid', 'invalid');
    }
  });
})();
//cargado desde src/views/partials/mixins/formUsersRegister.pug
